'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import React, { useState } from 'react';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { Card, CardContent, CardHeader } from '@eliadmin/core/src/components/ui/card';

type GalleryCardProps = {
  name: string;
  image: {
    url: string;
  };
  images: any;
};

const GalleryCard: React.FC<GalleryCardProps> = ({ name, image, images }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  const allImages = [image, ...images];

  return (
    <>
      <Card className="relative flex w-full flex-col bg-border hover:cursor-pointer">
        <button
          type="button"
          aria-label={name || 'Otvoriť galériu'}
          onClick={handleOpenGallery(allImages, 0)}
          className="absolute inset-0 z-10 h-full w-full rounded-[inherit] border-0 bg-transparent p-0"
        />
        <Image
          src={image.url}
          alt={resolveImageAlt(image, name)}
          width={0}
          height={0}
          sizes="100vw"
          className="h-[250px] w-full rounded-t-lg object-cover object-center lg:h-[300px]"
        />
        <CardContent className="text-center">
          <h2 data-ea-visual-tag="h3" className="mt-2">
            {name}
          </h2>
        </CardContent>
      </Card>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
    </>
  );
};

export default GalleryCard;
